import React, { useEffect, useMemo, useState } from "react"
import useReportColumns from "hooks/useReportColumns"
import { REPORT_COLUMN_KEYS } from "config/reportColumnDefinitions"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useDispatch, useSelector } from "react-redux"
import ProviderConsumptionReportListComponent2 from "components/ProviderReports/Consumption2"
import {
  exportMonitorConsumptionReports2,
  getMonitorConsumptionReports2,
} from "store/monitor-reports/monitor-report-action"
import {
  getMonitorIps,
  getMonitorItemCategories,
} from "store/monitor-dashboard/monitor-dashboard-action"
import { getMonitorConsumptionsProjects } from "store/monitor-consumption/monitor-consumption-action"
import MonitorConsumptionReportListComponent2 from "components/MonitorReports/Consumption2"

const MonitorConsumptionReportList2 = ({ from }) => {
  // Meta Title
  document.title = "Consumption Reports 2"

  const dispatch = useDispatch()

  // get consumptions
  const consumptions = useSelector(
    state => state.monitorReports.monitorConsumptionReport
  )

  // Current status of the export process for the consumption report, retrieved from the Redux store
  const exportStatus = useSelector(
    state => state.monitorReports.monitorConsumptionExport
  )

  const [according, setAccording] = useState({ order: "desc", name: "date" })
  const [advnacedSearch, setAdvancedSearch] = useState({})
  const { columns, visibleColumns, visibleKeys, toggleColumn, moveColumnToIndex } = useReportColumns(
    REPORT_COLUMN_KEYS.MONITOR_CONSUMPTION_TWO
  )

  const [pageNumber, setPageNumber] = useState(20)

  // Fetches new activity logs when a page number is clicked
  const onPageClick = link => {
    dispatch(
      getMonitorConsumptionReports2(
        link.url,
        pageNumber,
        according,
        advnacedSearch
      )
    )
  }

  // Updates the number of rows displayed based on user selection (e.g., 10, 20, 50)
  const onChangeRowNumber = value => {
    setPageNumber(value)
  }

  // Updates the ordering based on user selectio
  const onChangeOrdering = value => {
    if (value.order) {
      setAccording(prev => {
        return { ...prev, order: value.order }
      })
    }
    if (value.name) {
      setAccording(prev => {
        return { ...prev, name: value.name }
      })
    }
  }

  // fetch new Provider Distribution Action Requests based page number or according changes
  useEffect(() => {
    dispatch(
      getMonitorConsumptionReports2(
        undefined,
        pageNumber,
        according,
        advnacedSearch
      )
    )
  }, [according, pageNumber])

  // fetch consumption report and other data needs for file select box
  useEffect(() => {
    dispatch(getMonitorConsumptionsProjects())
    dispatch(getMonitorItemCategories())
    dispatch(getMonitorIps())
  }, [])

  // Updates search value when a new search is performed
  const onSearchHandler = data => {
    setAdvancedSearch(data)
    dispatch(
      getMonitorConsumptionReports2(undefined, pageNumber, undefined, data)
    )
  }

  // Trigger export process when Export button is clicked
  const onExportBtnClick = () => {
    dispatch(exportMonitorConsumptionReports2(according, advnacedSearch, visibleKeys))
  }

  return (
    <React.Fragment>
      <Breadcrumbs title={"Monitor"} breadcrumbItem={"Consumption Reports 2"} />
      {/* Monitor Consumption Report 2 Component  */}
      <MonitorConsumptionReportListComponent2
        data={consumptions?.data}
        error={consumptions?.error}
        loading={consumptions?.loading}
        onChangeOrdering={onChangeOrdering}
        onSearchHandler={onSearchHandler}
        onExportBtnClick={onExportBtnClick}
        exportStatus={exportStatus}
        onPageClick={onPageClick}
        onChangeRowNumber={onChangeRowNumber}
        columns={columns}
        visibleColumns={visibleColumns}
        onToggleColumn={toggleColumn}
        onReorder={moveColumnToIndex}
      />
    </React.Fragment>
  )
}

export default MonitorConsumptionReportList2
